import { heroLead } from '../data';

export default function HeroEdition() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-foreground-900/10 bg-background-50">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-8 md:px-6 md:py-12 lg:grid-cols-12 lg:gap-10">
        {/* left: 头条文本主区 */}
        <div className="lg:col-span-8">
          <div className="flex items-center justify-between border-b border-foreground-900/10 pb-3">
            <p className="kicker text-xs text-primary-600">
              <i className="ri-focus-3-line mr-2"></i>{heroLead.kicker}
            </p>
            <span className="text-[11px] tracking-widest text-foreground-500">{heroLead.issue}</span>
          </div>

          <h1 className="mt-6 font-heading text-[30px] font-semibold leading-[1.15] tracking-tight text-foreground-950 md:text-[46px] lg:text-[54px]">
            {heroLead.title.split('：')[0]}
            <span className="mt-3 block text-primary-600">：{heroLead.title.split('：')[1]}</span>
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">{heroLead.summary}</p>

          <div className="mt-6 flex flex-wrap items-center gap-4 border-t border-foreground-900/10 pt-4 text-[13px] text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-calendar-line text-foreground-600"></i>{heroLead.meta}
            </span>
            <span className="hidden h-3 w-px bg-foreground-900/10 sm:block"></span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-eye-line"></i>{heroLead.reads} 阅读</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-chat-3-line"></i>{heroLead.comments} 评论</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-share-forward-line"></i>{heroLead.shares} 转发</span>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href="#focus"
              className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
            >
              查看完整追踪 <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#debate"
              className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md border border-foreground-900/15 bg-transparent px-5 text-sm font-medium text-foreground-800 transition-colors hover:bg-foreground-50"
            >
              进热议现场 <i className="ri-chat-smile-3-line"></i>
            </a>
          </div>
        </div>

        {/* right: 克制配图 */}
        <div className="lg:col-span-4">
          <figure className="relative overflow-hidden rounded-lg">
            <div className="aspect-[3/4] w-full overflow-hidden rounded-lg">
              <img
                src={heroLead.image}
                alt="91黑料 今日焦点实况"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent p-4 pt-10 text-background-50">
              <span className="text-[11px] tracking-widest text-background-200">今日现场</span>
              <p className="mt-1 text-sm font-medium leading-snug text-background-50">热度正处关键拐点，多方立场尚未统一</p>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}